export const step8 = {
  popupChecked: false,
  commissions: [
    {
      title: '법인설립 수수료',
      originalPrice: 593000,
      salePrice: 178000,
    },
    {
      title: '최신 정관',
      originalPrice: 250000,
      salePrice: 0,
    },
    {
      title: '인감도장 제작비',
      originalPrice: 50000,
      salePrice: 0,
    },
    {
      title: '사업자등록비',
      originalPrice: 150000,
      salePrice: 0,
    },
    {
      title: '등기부등본, 인감증명서',
      originalPrice: 6000,
      salePrice: 0,
    },
    {
      title: '각종 법인양식',
      originalPrice: 100000,
      salePrice: 0,
    },
    {
      title: '부가가치세',
      originalPrice: null,
      salePrice: 17800,
    },
  ],

  openPopup() {
    this.popupChecked = true;

    document.querySelector('.step9-2').classList.add('active');
    document.querySelector('.app-popup-wrap').classList.add('active');
  },

  get isNextBtnActive() {
    return this.popupChecked;
  },
};
